"use strict";

export default class XHR {

  static Get(url, success, error) {
    const xhr = XHR.Prepare('GET', url, success, error);

    return XHR.Send(xhr);
  }

  static Prepare(method, url, success, error) {
    const xhr = new XMLHttpRequest();
    xhr.open(method, url);
    xhr.setRequestHeader('Accept-Language', document.querySelector('html').getAttribute('lang'));

    xhr.onreadystatechange = function (event) {
      if (typeof success === 'function') {
        if (xhr.readyState === 4) {
          if (Math.floor(xhr.status / 100) === 2) {
            if (xhr.responseText) {
              const contentType = xhr.getResponseHeader('Content-Type');

              if (contentType.split(',').indexOf('json') !== -1) {
                return success(JSON.parse(xhr.responseText));
              }
            }

            return success(xhr.responseText);
          } else {
            if (typeof error === 'function') {
              return error(xhr);
            }
          }
        }
      }

      return false;
    };

    return xhr;
  }

  static Send(xhr, data) {
    xhr.send(data);

    return xhr;
  }
}
